import { Box, ColorOptions, Icon, Loader, Spacer, Text } from '@jfs/ui-new'
import { isEmptyObject as isEmpty } from '@jfs/utils'
import { useNavigation } from '@react-navigation/native'
import { useCallback, useEffect, useState } from 'react'
import { SodexoIcon } from '../../assets/images/svg/Sodexo'
import { Button } from '../../comps/Button'
import { useLazyApiData, useStores } from '../../data/store'
import { Header } from '../../nav/PayStack'
import { convertHexToRGBA, isIFrame } from '../../utils'
import { ChildWindow } from '../PaymentProcesseing/ChildWindow'
import styles from './styles'
import { staticStrings } from '../../utils/string'
import Pluxee from '../../assets/images/svg/Pluxee'

const FoodCardFullScreenProcessing = () => {
  const {
    intentId,
    confirmPayment,
    returnurl,
    payLoad,
    theme,
    template,
    isValidTemplate,
    updateHeaderClose,
    isSinglePaymentModeAllowed,
    redirectUrl,
  } = useStores((root) => ({
    intentId: root.transaction.id.intentId,
    confirmPayment: root.confirmPaymentApi,
    returnurl: root.transaction.getMerchantRedirectingUrl(),
    payLoad: root?.transaction?.txnMeta?.payLoad ?? {},
    theme: root?.config?.merchantTheme,
    template: root.merchant.template,
    isValidTemplate: root.isValidTemplate,
    updateHeaderClose: root.config.updateHeaderClose,
    isSinglePaymentModeAllowed: root.merchant.isSinglePaymentModeAllowed,
    redirectUrl: root.transaction.initiatingEntity.returnUrl,
  }))

  console.log('FoodCardFullScreenProcessing opened')
  const { goBack, canGoBack } = useNavigation()

  const [isDisabled, setIsDisabled] = useState(false)
  const [confirmPaymentApi, { state: confirmPaymentState, data: confirmPaymentData }] = useLazyApiData(confirmPayment)
  const [errMsg, setErrMsg] = useState('')
  useEffect(() => {
    confirmPaymentApi()
  }, [confirmPaymentApi])

  useEffect(() => {
    if (confirmPaymentState === 'rejected') {
      console.log('confirmPaymentState data', confirmPaymentData)
      window.currentChild?.close()
      updateHeaderClose(true)
      setErrMsg(
        confirmPaymentData?.message ??
          'Sorry, your payment got declined by Pluxee, try using a different payment method',
      )
    }
  }, [confirmPaymentState, confirmPaymentData, updateHeaderClose])

  const handlePayment = () => {
    if (window.currentChild) {
      window.currentChild.focus()
    }
  }

  const NavigateToMerchant = useCallback(() => {
    // Linking.openURL(retUrl)
    // window.location.href = redirectUrl
    if (isIFrame()) {
      window.parent.postMessage(
        {
          txnId: 0,
          intentId,
          status: 'completed',
          message: '',
          rUrl: redirectUrl,
        },
        '*',
      )
    } else {
      //Linking.openURL(retUrl)
      window.location.href = redirectUrl
    }
  }, [intentId, redirectUrl])

  const onChangePayMethod = () => {
    console.log('onChangePayMethod called')
    if (isSinglePaymentModeAllowed()) {
      setIsDisabled(true)
      NavigateToMerchant()
    } else if (canGoBack()) {
      goBack()
    }
  }

  const style = styles(theme)
  if (errMsg) {
    return (
      <Box flex={1} {...style.centerAlignment}>
        <Pluxee width={72} height={24} />
        <Spacer direction={'vertical'} size={16} />
        <Text color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions} fontWeight="700">
          {staticStrings.sodexoPayUsing}
        </Text>
        <Box justifyContent="center" alignItems="center" width={'100%'}>
          <Spacer direction="vertical" size={32} />
          <Icon id="INFO" size={48} color={theme?.bodyTextColor as ColorOptions} />
          <Spacer direction="vertical" size={16} />
          <Box paddingHorizontal={32}>
            <Text
              textAlign="center"
              title={errMsg}
              fontSize={14}
              fontWeight="700"
              color={theme?.bodyTextColor as ColorOptions}
            />
          </Box>
          <Spacer direction="vertical" size={36} />
        </Box>

        <Box width="100%" paddingHorizontal={32}>
          <Button
            type="secondary"
            disabled={isDisabled}
            isFull={true}
            title={isSinglePaymentModeAllowed() ? 'Go back to merchant' : 'Change Payment method'}
            onPress={onChangePayMethod}
          />
        </Box>
      </Box>
    )
  }

  return (
    <>
      <Header
        title={staticStrings.sodexoHeader}
        hide={isValidTemplate(template.id)}
        onGoBack={() => {}}
        showGoBack={false}
        theme={theme}
      />
      <Box {...style.centerAlignment}>
        <ChildWindow hide={isEmpty(payLoad)} retUrl={returnurl} />
        <Spacer direction={'vertical'} size={72} />
        <Pluxee width={72} height={24} />
        <Spacer direction={'vertical'} size={16} />
        <Text color={convertHexToRGBA(theme?.bodyTextColor, 40) as ColorOptions} fontFamily="jioType-medium">
          {staticStrings.sodexoPayUsing}
        </Text>

        <Box alignItems={'center'} justifyContent={'center'}>
          <Spacer direction="vertical" size={32} />
          <Loader type={'large'} color={theme?.brandColor as ColorOptions} />
          <Spacer direction="vertical" size={32} />
          <Text
            title="Please wait..."
            fontSize={12}
            fontFamily="jioType-light"
            color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
          />
          <Text
            title="We are processing your payment with Pluxee,"
            fontSize={12}
            fontFamily="jioType-light"
            color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
          />
          <Text
            title="This might take few moment..."
            fontSize={12}
            fontFamily="jioType-light"
            color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
          />
          {isIFrame() && (
            <>
              <Spacer direction="vertical" size={32} />
              <Box width="100%" marginRight={16}>
                <Button
                  title="Go Back To Payment"
                  isFull={true}
                  testID="backToPaymentTest"
                  type="secondary"
                  onPress={handlePayment}
                />
              </Box>
            </>
          )}
        </Box>
      </Box>
    </>
  )
}

export { FoodCardFullScreenProcessing }
